import { Neutral500, Warning500, Warning800 } from '@src/utils/colors';

// Gold, silver and bronze, then plain numbers for the rest.
const MEDAL_COLORS = [Warning500, Neutral500, Warning800];

interface CitationMedalProps {
  // 1-based place.
  place: number;
}

export const CitationMedal = ({ place }: CitationMedalProps) => (
  <span
    className='aars-medal'
    style={{ backgroundColor: MEDAL_COLORS[place - 1] }}
    title={`#${place}`}
  >
    {place}
  </span>
);
